import { render } from "./policies.vue?vue&type=template&id=0894437c"
import script from "./policies.vue?vue&type=script&lang=js"
export * from "./policies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__